<div [ngStyle]="{'padding': fieldAdminStyle ? '0 30px' : ''}">
    <div class="link-field-container" *ngIf="!this.seasonFormData?.field?.isInAnotherActiveSeason">
        <!-- <div class="link-field-items">
            <div class="add-btn-sm" mat-flat-button type="button" (click)="openCreateNewSeasonDialog()">
                <div>
                    <img src="../../assets/icons/add_icon.svg" alt="Attach Icon" class="add-btn-sm-icon">
                </div>
            </div>
        </div> -->


        <div class="link-field-items">
            <form [formGroup]="linkFieldForm">
                <mat-form-field style="width: 200px;margin-top: 20px" appearance="outline">
                    <mat-label> Linked Season</mat-label>
                    <mat-select formControlName="season" (selectionChange)="setSelectedSeason($event.value)">
                        <mat-option *ngFor="let season of seasons" [disabled]="season?.status?.id === 3" [value]="season">
                            {{season.name + ' (' + season.status.description + ')'}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>

        <div class="link-field-items">
            <button class="basic-btn-white-font basic-btn-primary-bg" mat-flat-button type="button" (click)="openLinkSeasonDialog()" [disabled]="isControlDisabled || selectedSeason?.status?.id === 3 || !selectedSeason" [ngClass]="{'btn-disabled': isControlDisabled}">
                <div class="btn-content">
                        <span>
                            <p class="btn-text">LINK</p>
                        </span>
                </div>
            </button>

        </div>

    </div>

    <section class="py-3 px-4" *ngIf="seasonFormData?.field?.isInAnotherActiveSeason && !hideSeasonDetails">

        <div class="mb-2">
            <div class="text-[12px] font-bold text-[var(--base-text-dark)] mb-1">Season: {{seasonFormData ? seasonFormData.season.name : placeholder}}</div>
            <div class="flex items-center flex-wrap gap-x-1 text-[11px] text-[var(--tertiary-text)]">
                <span class="font-semibold">Date Created:</span> <span>{{seasonFormData ? dayjs(seasonFormData.season.creationDate).format(dateStringFormatting) : placeholder}}</span>
                <span class="mx-1">|</span>
                <span class="font-semibold">Start:</span> <span>{{seasonFormData ? dayjs(seasonFormData.season.startDate).format(dateStringFormatting) : placeholder}}</span>
                <span class="mx-1">|</span>
                <span class="font-semibold">End:</span> <span>{{seasonFormData ? dayjs(seasonFormData.season.endDate).format(dateStringFormatting) : placeholder}}</span>
                <span class="mx-1">|</span>
                <span class="font-semibold">Fields:</span> <span>{{seasonFormData ? seasonFormData.season.totalFields : placeholder}}</span>
            </div>
        </div>

        <div class="downloads-container">
            <mat-accordion class="field-details-downloads-btn">
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" style="width: 200px;">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="field-details-downloads-btn-text" style="font-size: 12px;">
                            Season Options
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div (click)="manageSeason()" class="download-container">
                        <div type="button" class="downloads-option-text-container">
                            <p class="field-details-downloads-option-text text-no-margin text-[12px]">Manage season</p>
                        </div>
                    </div>
                    
                    <div (click)="openCreateNewSeasonDialog()" class="download-container">
                        <div type="button" class="downloads-option-text-container">
                            <p class="field-details-downloads-option-text text-no-margin text-[12px]">Create season</p>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

    </section>

    <div>
        <hr style="border-top: 1px solid #e0dfdf; width: 100%; margin-bottom: 20px;">
    </div>
</div>
